import { useEffect, useState } from 'react';
import useReveal from '@/hooks/useReveal';
import SiteNav from './components/SiteNav';
import Hero from './components/Hero';
import HotRanking from './components/HotRanking';
import FeedGrid from './components/FeedGrid';
import Timeline from './components/Timeline';
import Discussion from './components/Discussion';
import Press from './components/Press';
import TagSummary from './components/TagSummary';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  useReveal();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <HotRanking />
        <FeedGrid />
        <Timeline />
        <Discussion />
        <Press />
        <TagSummary />
      </main>
      <SiteFooter />

      <a
        href="#top"
        aria-label="回到顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 transition-all duration-300 hover:bg-primary-600 cursor-pointer ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-lg" />
      </a>
    </div>
  );
}